// extracted by mini-css-extract-plugin
export var browseMoreNav = "feature-preview-grid-module--browseMoreNav--8b53c typography-module--small--2877f";
export var grid = "feature-preview-grid-module--grid--a4411";
export var headline = "feature-preview-grid-module--headline--0f023 typography-module--responsiveTitle2SansCentered--e59b8";
export var root = "feature-preview-grid-module--root--56c6a";